import React from 'react';
import PropTypes from 'prop-types';

import twoColumnMainContentDefaultOptions from 'js/block-area/two-column-main-content-default-options';
import sidebarDefaultOptions from 'js/block-area/sidebar-default-options';

import ComponentList from 'components/component-list';
import Columns from 'components/columns';

const TwoColumnBlock = ({
  mainColumnBlocks,
  sidebarColumnBlocks,
  sidebarIsLeft
}) => {
  const sidebar = sidebarColumnBlocks ? (
    <ComponentList {...sidebarColumnBlocks} {...sidebarDefaultOptions} />
  ) : null;

  return (
    <Columns className="article-page__text">
      {sidebarIsLeft && <Columns.Sidebar>{sidebar}</Columns.Sidebar>}
      <Columns.Main>
        {mainColumnBlocks && (
          <ComponentList
            {...mainColumnBlocks}
            {...twoColumnMainContentDefaultOptions}
          />
        )}
      </Columns.Main>
      {!sidebarIsLeft && <Columns.Sidebar>{sidebar}</Columns.Sidebar>}
    </Columns>
  );
};

TwoColumnBlock.propTypes = {
  mainColumnBlocks: PropTypes.exact(ComponentList.propTypes),
  sidebarColumnBlocks: PropTypes.exact(ComponentList.propTypes),
  sidebarIsLeft: PropTypes.bool
};

export default TwoColumnBlock;
